import { useEffect, useRef, useState } from "react";
import { InsureframeModals } from "./Modals/InsureframeModals";
import { hideToast, showToast } from "../../utils/notification";
import { TermsModal } from "./Modals/TermsModal";
import { useLocation, useNavigate } from "react-router-dom";

export const Insureframe = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const iframeRef = useRef();
  const iframeContainerRef = useRef();
  const [iframeReady, setIframeReady] = useState(false);
  const [currentTheme, setCurrentTheme] = useState(null);
  const [readingTerms, setReadingTerms] = useState(!!props.terms);

  useEffect(() => {
    setCurrentTheme(localStorage.getItem("theme"));
  }, []);

  const [modal, setModal] = useState({
    opened: false,
  });

  let url = "";
  switch (props.product) {
    case "pad":
      url = props?.offerId?.length ? `/summary/pad/${props?.offerId}` : "/pad";
      break;
    case "travel":
      url = props?.offerId?.length
        ? `/summary/travel/${props?.offerId}`
        : "/travel";
      break;
    case "house":
      url = props?.offerId?.length
        ? `/summary/house/${props?.offerId}`
        : "/house";
      break;
    case "casco":
      url = props?.offerId?.length
        ? `/summary/casco/${props?.offerId}`
        : "/casco";
      break;
    default:
      url = props?.offerId?.length ? `/summary/${props?.offerId}` : "";
  }

  useEffect(() => {
    const readMessageFromIframe = function (event) {
      if (event.data && iframeRef) {
        switch (event.data.eventName) {
          case "HEIGHT_CHANGE": {
            if (iframeContainerRef.current) {
              iframeContainerRef.current.style.height = `${event.data.details.height + 30}px`;
            }
            break;
          }
          case "SCROLL_TO": {
            const frameOffsetTop = iframeRef.current.offsetTop;
            const elementOffsetTop = event.data.details.offsetTop;
            const behavior = event.data.details.behavior;

            window.scrollTo({
              top: frameOffsetTop + elementOffsetTop - 50,
              behavior: behavior || "smooth",
            });
            break;
          }
          case "OFFER_SELECTION": {
            switch (props.product) {
              case "pad":
                navigate(`/pad/${event.data.details.offerId}`);

                localStorage.setItem(
                  "pad-offerId",
                  event.data.details.offerId.toString()
                );
                break;
              case "travel":
                navigate(`/travel/${event.data.details.offerId}`);

                localStorage.setItem(
                  "travel-offerId",
                  event.data.details.offerId.toString()
                );
                break;
              case "house":
                navigate(`/house/${event.data.details.offerId}`);

                localStorage.setItem(
                  "house-offerId",
                  event.data.details.offerId.toString()
                );
                break;
              case "casco":
                navigate(`/casco/${event.data.details.offerId}`);

                localStorage.setItem(
                  "casco-offerId",
                  event.data.details.offerId.toString()
                );
                break;
              default:
                navigate(`/rca/${event.data.details.offerId}`);

                localStorage.setItem(
                  "offerId",
                  event.data.details.offerId.toString()
                );
            }
            break;
          }
          case "MODAL_CONFIRM_INIT": {
            setModal({
              opened: true,
              type: "confirm",
              ...event.data.details,
              onClose: () => {
                setModal({
                  opened: false,
                });

                iframeRef.current.contentWindow.postMessage(
                  {
                    eventName: "MODAL_CONFIRM_RESPONSE",
                    details: {
                      modalId: event.data.details.modalId,
                      confirm: false,
                    },
                  },
                  "*"
                );
              },
              onConfirm: () => {
                switch (event.data.details.modalId) {
                  case "terms-and-condition": {
                    iframeRef.current.contentWindow.postMessage(
                      {
                        eventName: "MODAL_CONFIRM_RESPONSE",
                        details: {
                          modalId: event.data.details.modalId,
                          confirm: true,
                        },
                      },
                      "*"
                    );
                    break;
                  }

                  case "payment-redirection":
                    window.open(event.data.details.paymentLink, "_self");
                    break;

                  case "prepare-download":
                    window.open(event.data.details.documentUrl, "_blank");
                    break;
                }

                setModal({
                  opened: false,
                });
              },
            });
            break;
          }
          case "IFRAME_NOTIFICATION": {
            showToast({
              content: event.data.details.message,
              type: event.data.details.type,
              toastId: event.data.details.id,
              loading: event.data.details.loading,
            });
            break;
          }
          case "IFRAME_HIDE_NOTIFICATION": {
            hideToast(event.data.details.id);
            break;
          }
          case "COPY_TEXT":
            navigator.clipboard.writeText(event.data.details.text);
            break;
          case "NEW_POLICY":
            localStorage.removeItem("offerId");
            break;
          case "INSUREFRAME_READY":
            setIframeReady(true);
            break;
          case "DOWNLOAD_FILE": {
            const blobUrl = URL.createObjectURL(event.data.details.blob);
            const isIOSChrome = /CriOS/i.test(navigator.userAgent);

            setTimeout(() => {
              if (isIOSChrome) {
                window.open(blobUrl, "_blank");
              } else {
                const link = document.createElement("a");
                link.download = event.data.details.fileName;
                link.href = blobUrl;
                link.click();
              }
            }, 0);

            break;
          }
        }
      }
    };

    window.addEventListener("message", readMessageFromIframe);

    return () => {
      window.removeEventListener("message", readMessageFromIframe);
    };
  }, [navigate]);

  return (
    <>
      {props.terms && (
        <TermsModal
          open={readingTerms}
          setOpen={setReadingTerms}
          terms={props.terms}
        />
      )}
      {modal.opened && <InsureframeModals modal={modal} />}

      {!iframeReady && (
        <div
          role="status"
          className="max-w-100 animate-pulse space-y-4 divide-y divide-gray-200 rounded border border-gray-200 p-4 shadow dark:divide-gray-700 dark:border-gray-700 md:p-6"
        >
          {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((i) => (
            <div
              key={`skeleton-${i}`}
              className="flex items-center justify-between"
            >
              <div>
                <div className="mb-2.5 h-2.5 w-24 rounded-full bg-gray-300 dark:bg-gray-600"></div>
                <div className="h-2 w-32 rounded-full bg-gray-200 dark:bg-gray-700"></div>
              </div>
              <div className="h-2.5 w-12 rounded-full bg-gray-300 dark:bg-gray-700"></div>
            </div>
          ))}

          <span className="sr-only">Se încarcă comparatorul...</span>
        </div>
      )}

      {!readingTerms && (
        <div id="insureframe-container" ref={iframeContainerRef}>
          <iframe
            ref={iframeRef}
            src={`${props.insureframeUrl}${url}?${props.insureframeCutomUrl}&apiKey=${props.insureframeApiKey}&theme=${currentTheme === "dark" ? "dark" : "light"}&parentLocation=%2F${props.product}%2F%3AofferId${location.search.size ? `&${location.search.toString()}` : ""}`}
            style={{
              overflow: "hidden",
              height: "100%",
              width: "100%",
              visibility: iframeReady ? "visible" : "hidden",
              opacity: iframeReady ? 1 : 0,
            }}
            name="insureframe"
            id="insureframe"
            height="100%"
            width="100%"
            allowFullScreen
          ></iframe>
        </div>
      )}
    </>
  );
};
